import disk from '../../polyMesh/geometric/primitives/Disk';

const Disk = {
  schema: {
    radius: { type: 'Number', label: 'Radius', defaultValue: 0.5, minValue: 0.0, step: 0.1, animatable: true },
    segments: { type: 'Integer', label: 'Segments', defaultValue: 12, minValue: 3, maxValue: 200, animatable: true },
    thetaStart: { label: 'Theta Start', type: 'Number', defaultValue: 0, minValue: 0, maxValue: 360, step: 10, animatable: true },
    thetaLength: { label: 'Theta Length', type: 'Number', defaultValue: 360, minValue: 0, maxValue: 360, step: 10, animatable: true },
    removeDuplicate: { label: 'Remove Duplicate Vertices', type: 'Boolean', defaultValue: false, hidden: true },
  },

  update: function (operator, primitive) {
    const { radius, segments, thetaStart, thetaLength } = operator;
    primitive.mesh = disk(radius, segments, thetaStart, thetaLength);
  },
};

export default Disk;




// WEBPACK FOOTER //
// ./src/operators/PolyMesh/Disk.js